"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.formatTransactionStatus = exports.toTransactionStatusRaw = exports.fromTransactionStatusRaw = void 0;
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var bignumber_js_1 = require("bignumber.js");
var errors_1 = require("@ledgerhq/errors");
var account_1 = require("../account");
var serialization_1 = require("../families/bitcoin/serialization");
var currencies_1 = require("../currencies");
var account_2 = require("../families/bitcoin/account");
var env_1 = require("../env");
var fromErrorRaw = function (raw) {
    return (0, errors_1.deserializeError)(JSON.parse(raw));
};
var toErrorRaw = function (raw) {
    return JSON.stringify((0, errors_1.serializeError)(raw)) || "{}";
};
var fromTransactionStatusRaw = function (ts) { return ({
    errors: (0, mapValues_1["default"])(ts.errors, fromErrorRaw),
    warnings: (0, mapValues_1["default"])(ts.warnings, fromErrorRaw),
    estimatedFees: new bignumber_js_1.BigNumber(ts.estimatedFees),
    amount: new bignumber_js_1.BigNumber(ts.amount),
    totalSpent: new bignumber_js_1.BigNumber(ts.totalSpent),
    recipientIsReadOnly: ts.recipientIsReadOnly,
    txInputs: ts.txInputs ? ts.txInputs.map(serialization_1.fromBitcoinInputRaw) : undefined,
    txOutputs: ts.txOutputs ? ts.txOutputs.map(serialization_1.fromBitcoinOutputRaw) : undefined
}); };
exports.fromTransactionStatusRaw = fromTransactionStatusRaw;
var toTransactionStatusRaw = function (ts) { return ({
    errors: (0, mapValues_1["default"])(ts.errors, toErrorRaw),
    warnings: (0, mapValues_1["default"])(ts.warnings, toErrorRaw),
    estimatedFees: ts.estimatedFees.toString(),
    amount: ts.amount.toString(),
    totalSpent: ts.totalSpent.toString(),
    recipientIsReadOnly: ts.recipientIsReadOnly,
    txInputs: ts.txInputs ? ts.txInputs.map(serialization_1.toBitcoinInputRaw) : undefined,
    txOutputs: ts.txOutputs ? ts.txOutputs.map(serialization_1.toBitcoinOutputRaw) : undefined
}); };
exports.toTransactionStatusRaw = toTransactionStatusRaw;
var formatErrorSmall = function (e) {
    return e.name === "Error" ? e.message : e.name;
};
var formatTransactionStatus = function (t, _a, mainAccount) {
    var errors = _a.errors, warnings = _a.warnings, estimatedFees = _a.estimatedFees, amount = _a.amount, totalSpent = _a.totalSpent, txInputs = _a.txInputs, txOutputs = _a.txOutputs;
    var str = "";
    var account = (t.subAccountId &&
        (mainAccount.subAccounts || []).find(function (a) { return a.id === t.subAccountId; })) ||
        mainAccount;
    if (txInputs) {
        var n = (0, env_1.getEnv)("DEBUG_UTXO_DISPLAY");
        var displayAll = txInputs.length <= n;
        str +=
            "\nTX INPUTS (".concat(txInputs.length, "):\n") +
                txInputs
                    .slice(0, displayAll ? txInputs.length : n)
                    .map(function (o) { return (0, account_2.formatInput)(mainAccount, o); })
                    .join("\n");
        if (!displayAll) {
            str += "\n...";
        }
    }
    if (txOutputs) {
        str +=
            "\nTX OUTPUTS (".concat(txOutputs.length, "):\n") +
                txOutputs.map(function (o) { return (0, account_2.formatOutput)(mainAccount, o); }).join("\n");
    }
    str +=
        "\n  amount: " +
            (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(account), amount, {
                showCode: true,
                disableRounding: true
            });
    str +=
        "\n  estimated fees: " +
            (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(mainAccount), estimatedFees, {
                showCode: true,
                disableRounding: true
            });
    str +=
        "\n  total spent: " +
            (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(account), totalSpent, {
                showCode: true,
                disableRounding: true
            });
    var errorKeys = Object.keys(errors);
    if (errorKeys.length) {
        str +=
            "\n  errors: " +
                errorKeys.map(function (k) { return "".concat(k, ": ").concat(formatErrorSmall(errors[k])); }).join(", ");
    }
    var warningKeys = Object.keys(warnings);
    if (warningKeys.length) {
        str +=
            "\n  warnings: " +
                warningKeys
                    .map(function (k) { return "".concat(k, ": ").concat(formatErrorSmall(warnings[k])); })
                    .join(", ");
    }
    return str;
};
exports.formatTransactionStatus = formatTransactionStatus;
//# sourceMappingURL=status.js.map